<template>
<div class="chapter">
<div class="inner_page">
<p class="style2501"><a id="page_7">CHAPTER 2<br/><br/></a></p><a id="page_7">
<p class="style26">With his next-to-last $50 bill, Partain paid off the driver of the gypsy
cab he had hailed and haggled with at LAX. As the cab sped away, he pocketed the $25 in
change and turned to inspect the private hospital that was on the north side of Olympic
Boulevard a few blocks east of Century City.</p>
<p class="style24">It was just past 6 <span class="SB">P</span>.<span class="SB">M</span>.
and dark on the January Tuesday that was Twelfth Night. Partain found himself wondering
whether the hospital had already taken down its holiday decorations or just
hadn’t bothered to put any up. He didn’t care either way but regarded his
mild curiosity as surprising, perhaps even encouraging.</p>
<p class="style24">As Partain studied the hospital, he began to suspect its architect had
been enamored of long slabs of pale granite, and that its landscape designer had been
equally smitten by drought-resistant plants—the expensive kind that still look
thirsty even in a hard rain. Significant money also had gone into the hospital's
outdoor security lighting system and Partain, who knew about such things, could find
little fault with it.</p>
<p class="style24">He entered the hospital, carrying his Cape buffalo bag, avoided the reception desk, rode an elevator to the top floor, the sixth, and
slipped into a spacious corner room where the Greek had told him his prospective
employer lay dying of some rare but undiagnosed ailment.</p>
<p class="style24">Partain found her sitting cross-legged on a hospital bed, wearing a
Chinese-red silk robe decorated with numerous small gold dragons who were either yawning
or roaring at each other. She had just finished a slice—the last slice, he
noticed—of a small pizza, eating it out of the box it had been delivered in, and
was now washing the last bite down with what little remained in a bottle of
Beck's beer.</p>
<p class="style24">She lowered the bottle, stared at him for a moment with clever-looking,
not quite gray eyes and said, “Edd-with-two-ds Partain, I hope and
trust.”</p>
<p class="style24">“They sometimes called me that—Twodees,” he said.
“In grade school mostly.”</p>
<p class="style24">“Then I’d almost bet the Partains were Cajuns and probably
in the oil bidness down around where—Opelousas? Lafayette?” She gave him a
quick grin, showing off perfect teeth that Partain took to be perfectly capped.
“Sorry,” she said, “but I do like to make up tales about fellas
I’ve just met.”</p>
<p class="style24">“My folks moved from El Paso to Bakersfield right after the
war,” he said. “My old man was an over-the-road hauler and my mother ran a
beauty shop out of their living room. I suspect the Partains were French Huguenots way
back, but I never asked.”</p>
<p class="style24">“Well, you already know I’m Millicent Altfford or you
wouldn’t be here,” she said, laying the empty beer bottle on its side in
the empty pizza box. She then removed both box and bottle from her lap, placed them on
the bed, slipped gracefully from her cross-legged perch to the floor and asked,
“Want a beer?”</p>
<p class="style24">Partain said yes, thanks, and thought her come-and-go Red River Valley
drawl must have originated at least 40 miles northeast of Dallas and not much less than
190 miles south of Oklahoma City. When the drawl went away, it was
replaced by something cool and crisp out of Chicago, where, the Greek said, she had
spent four years at Foote, Cone and Belding before signing on as a fund-raiser for the
second Adlai Stevenson presidential campaign in 1956.</p>
<p class="style24">Altford glided barefoot to a small built-in bar that provided gin, Scotch
and vodka but no bourbon. There were also some glasses, a tiny stainless-steel sink and,
below that, a miniature refrigerator sheathed in a grainy brown Formica that looked
nothing at all like walnut veneer.</p>
<p class="style24">Bending from the waist, she opened the refrigerator door and, with legs
still straight and eyes now almost at knee level, peered inside and offered to fix
Partain a real nice pastrami on rye with stuff the Stage Deli had sent over. Partain
thanked her but said he had eaten on the plane.</p>
<p class="style24">She straightened as effortlessly as she had bent over—a bottle of
Beck's in either hand—and turned to stare at him with an expression of
what he assumed was sympathy. “You eat on planes?”</p>
<p class="style24">“An economy measure,” he said, lowering his overnight bag
to the floor.</p>
<p class="style24">“Well, we’ll have to fix that, won’t we?” she
said and shut the refrigerator door with a backward kick of her bare left foot—a
movement Partain suspected of being practiced and maybe even choreographed.</p>
<p class="style24">After crossing the room to hand him a beer, Millicent Altford turned and
sank down onto a dark blue three-cushion couch, giving its center one a couple of
invitational pats. Once both were seated, a cushion between them, Partain tasted his
beer and said, “They told me you were dying. I assume they lied.”</p>
<p class="style24">“I told ‘em to lie. That way, if I didn’t take to
you right off, I could say: ‘Sorry. Forget it. I’m just too busy
dying.’“</p>
<p class="style24">“Since you’re neither sick nor dying, it might be suspected
you’re hiding from something or somebody.” He again looked around the large private corner room. “Although this has got to be one
hell of an expensive place to hide.”</p>
<p class="style24">“It’d cost anybody else or their insurance company at least
two thousand a day—plus.”</p>
<p class="style24">“Plus what?”</p>
<p class="style24">“Gourmet meals. The hospital went and hired itself a French chef
with a yard-long menu, and now you can lie abed of a morning and spend an hour or so
figuring out what you’re gonna eat for the rest of the day and on into the night.
But to me it's all free-gratis-for-nothing.”</p>
<p class="style24">“Why?”</p>
<p class="style24">“Because when they first started planning this thing back in
‘eighty-three, they needed a million or so in seed money. I raised it in four
days, didn’t charge a dime for my services and now, well, now I’ve got
myself sort of a permanent due bill.”</p>
<p class="style24">“They actually cure anything here?”</p>
<p class="style24">“They’re said to be hell on the clap.”</p>
<p class="style24">To Partain she looked more like 52 than 62 despite the cap of thick
short-cropped hair that had the color and sheen of old silver newly polished. Block out
the hair, he thought, or dye it back to what must’ve been its original
honey-blond, and she might, with the light behind her, pass for 41—your age.</p>
<p class="style24">Altford moved her legs around beneath the long red silk robe until they
were back in their cross-legged position. She had a swallow of beer from the bottle and
stared at Partain for a moment before she said, “Tell me about you and Nick
Patrokis and all those renegade ex-spooks who call themselves BARF or VOMIT or some
such.”</p>
<p class="style24">Partain took his time before replying. “It began as Veterans of
Military Intelligence, with VMI as its abbreviation. But when the Virginia Military
Institute squawked, Nick and the rest of them thought up VOMI, which nobody liked. But
because most of its members are fucked-over and otherwise disenchanted veterans of some
kind of military intelligence, they decided, just for the hell of it, to
call themselves Victims of Military Intelligence Treachery, which comes out VOMIT and
makes an acronym nobody else’d want. It also got them some publicity, and
that's the other reason they chose it.”</p>
<p class="style24">“How long’ve you been a member?”</p>
<p class="style24">“I’m not anymore,” Partain said. “I
can’t afford the dues.”</p>
<p class="style24">“How much are they?”</p>
<p class="style24">“Twenty-five a year.”</p>
<p class="style24">“Twenty-five <i>hundred?”</i></p>
<p class="style24">“Twenty-five dollars.”</p>
<p class="style24">She grinned. “You <i>are</i> broke.”</p>
<p class="style24">“Or poor,” he said. “I think there's a slight
but significant difference.” He had more of his beer, then asked,
“How’d you hook up with Nick?”</p>
<p class="style24">“I have an old boyfriend who's a retired brigadier
general?” she said, using the rising inflection indigenous to the Red River
Valley and much of the South.</p>
<p class="style24">“Army or Marines?”</p>
<p class="style24">“Army. Truth is, he's the only general I’ve ever
really known. But when he was my boyfriend back during the tail end of the Korea thing,
he was a captain with funny politics.”</p>
<p class="style24">“How funny?”</p>
<p class="style24">“He was a Stevenson Democrat.”</p>
<p class="style24">“That's pretty funny from what I’ve
read.”</p>
<p class="style24">“A dozen years later, early Vietnam time, he was a
colonel.”</p>
<p class="style24">“And a fairly rapid riser.”</p>
<p class="style24">“Goddamn brilliant, too. They sent him to Vietnam in
‘sixty-five and made him a brigadier in ‘sixty-seven. By then, he had his
twenty years in. So in ‘sixty-eight he came out against the war and
retired.”</p>
<p class="style24">“In that order?”</p>
<p class="style24">She thought about it. “In that order.”</p>
</a><p class="style24"><a id="page_7"></a><a id="page_12">“You still see him?”</a></p><a id="page_12">
<p class="style24">“He's had two wives and I’ve had three husbands. But
he and I still get it on now and then. After I started looking for somebody, I called
and told him I needed to hire me some brains and brawn. He said they seldom came in the
same box but, if they did, Nick Patrokis’d probably know where. So I called Nick
and he called back with your name.”</p>
<p class="style24">“Then you don’t really know Nick?”</p>
<p class="style24">“Just over the phone. But I expect you know him pretty
well.”</p>
<p class="style24">“We met in Vietnam, where he had some rotten luck,” Partain
said and waited for her to ask what kind of rotten luck. When she didn’t, his
estimate of her rose a few degrees.</p>
<p class="style24">“Tell me about VOMIT,” she said.</p>
<p class="style24">“It's really a one-man organization. Nick's a
cofounder and executive director. He's also the publicist, fund-raiser,
speakers’ bureau, bookkeeper, gofer and editor of its now-and-again newsletter.
He and VOMIT share an office with a skip-tracer on Connecticut Avenue a few blocks north
of Dupont Circle—you know Washington?”</p>
<p class="style24">She nodded.</p>
<p class="style24">“Well, the office is above a Greek restaurant owned by
Nick's uncle. Nick eats there free. The uncle also owns the building and
doesn’t charge VOMIT any rent. A few of the more crabby members, some
sympathizers and even a groupie or two usually show up Saturday afternoons to carp and
bitch and clean up and help with the mailings and such.”</p>
<p class="style24">Altford nodded again, abruptly this time, signalling she now knew all she
would ever need to know about VOMIT. “So how’d you get to be a victim of
military intelligence treachery?” she said.</p>
<p class="style24">“I hit a superior officer and was permitted to resign my
commission for the good of the service.”</p>
<p class="style24">“How superior?”</p>
</a><p class="style24"><a id="page_12"></a><a id="page_13">“A colonel.”</a></p><a id="page_13">
<p class="style24">“And you were what?”</p>
<p class="style24">“A major.”</p>
<p class="style24">“How hard you hit him?” “I beat the shit out of
him.” “Why?”</p>
<p class="style24">“You need a reason?”</p>
<p class="style24">“Yes, sir, I believe I do.”</p>
<p class="style24">“He lied to me.”</p>
<p class="style24">“All this happened where?”</p>
<p class="style24">“El Salvador.”</p>
<p class="style24">“When?”</p>
<p class="style24">“Nineteen-eighty-nine.”</p>
<p class="style24">A silence followed that Millicent Altford ended before it bothered either
of them. “You say you were also in Vietnam. You don’t look old
enough.”</p>
<p class="style24">“From nineteen-seventy to ‘seventy-five.”
“Right to the rotten end, huh?” He nodded.</p>
<p class="style24">“I thought all you guys went home after
‘seventy-three.”</p>
<p class="style24">“A few stayed on.”</p>
<p class="style24">“Until ‘seventy-five?”</p>
<p class="style24">He nodded again.</p>
<p class="style24">“Then where’d you go?” she asked.</p>
<p class="style24">“Back to the States for a while, then to Germany for four years,
stateside again, then to Tegucigalpa and on to El Salvador.”</p>
<p class="style24">“Why there? I mean why you in particular?”</p>
<p class="style24">“I like to think it was because of my outstanding leadership
qualities. Actually, it was because I speak Spanish.”</p>
<p class="style24">“Learned where—El Paso?”</p>
</a><p class="style24"><a id="page_13"></a><a id="page_14">“From my mother. Her name was Sandoval. Beatriz
Sandoval.”</a></p><a id="page_14">
<p class="style24">“How long were you in, all in all?”</p>
<p class="style24">“Nineteen years.”</p>
<p class="style24">“No pension?”</p>
<p class="style24">“None.”</p>
<p class="style24">“Where’ve you been working recently?”</p>
<p class="style24">“Until Christmas Day, I was a clerk at a gun store in Sheridan,
Wyoming.”</p>
<p class="style24">“What happened—the economy?”</p>
<p class="style24">“Irreconcilable differences with management.”</p>
<p class="style24">Altford grinned, placed her now empty beer bottle on the blond coffee
table and shifted around on the blue couch until, still cross-legged, she faced
Partain.</p>
<p class="style24">“You wanta go to work for me?”</p>
<p class="style24">“Depends on what or who you’re hiding from.”</p>
<p class="style24">“Little Rock.”</p>
<p class="style24">Because she seemed to be expecting or even needing some kind of reaction,
Partain said, “No kidding?” and “Why?”</p>
<p class="style24">“Partly because they’re real grateful for the two-point-six
million in soft money I raised for the party. But shoot, that's what I hired on
to do. What they’re real, <i>real</i> grateful for is the two hundred and
fifty-four thousand I bundled up for <i>them</i>, not the party, just three days after
the New Hampshire primary. Check that <i>after</i>. And to do that I had to talk two
hundred and fifty-four close personal friends into Fed Exing me checks for a thousand
apiece made out to Little Rock's campaign. And you’re damn right I
delivered that bundle in person.”</p>
<p class="style24">“So why all the hide-and-seek?”</p>
<p class="style24">“Because Little Rock wants to do something nice for me, and to
them something nice might mean ambassador to Togo or some such and I’m just not
cut out for stuff like that. But I didn’t want to hurt their
feelings, so I checked in here real sick and plan to stay that way ‘til it all
blows over and they forget about it, which I figure’ll take another three days,
maybe four.”</p>
<p class="style24">“That's what you do, then—raise political
money?”</p>
<p class="style24">“I’m a rainmaker and a good one. In odd years I sometimes
go back to the plushbottoms I’ve hit up and try and put ‘em together with
a few solid guys I know who can make big bucks even bigger. When it works, I get a small
percentage and the plushbottoms are so grateful they’re almost happy to see me
the next time I drop by to shake their money trees.”</p>
<p class="style24">“Let's get to it,” Partain said. “What
d’you want with me?”</p>
<p class="style24">“One-point-two million in political funds have gone missing.
Stolen, for sure. Maybe embezzled. I want it back.”</p>
<p class="style24">“I wouldn’t know where to start.”</p>
<p class="style24">“Yeah, but I do,” she said. “But while I’m
doing it—and, O Sweet Jesus, I’ve just been dying to say this all
day—I need somebody to ride shotgun.”</p>
<p class="style24">Partain smiled. “I think I could handle that.”</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter-02.vue?b4804c9e